/**
 * Created by piotr.pozniak@thebeaverhead.com on 17/08/2022.
 */

import { CT, IT } from "../../../consts";

const boxShadowOptions = [
  { label: "None", value: "none" },
  {
    label: "Light",
    value: "0px 4px 8px 0px rgba(0, 0, 0, 0.17)",
  },
  {
    label: "Strong",
    value: "0px 7px 11px 0px rgba(0, 0, 0, 0.27)",
  },
];

export const definitions = {
  title: "Card's styles",
  icon: "brush",
  groups: [
    {
      label: "Card",
      options: [
        {
          title: "Card's image container color",
          templates: [CT.card, CT.cardList, CT.cardSlider],
          integrations: [IT.google],
          name: "cardImgContainerColor",
          defaultValue: "#b476c9",
          style: {
            selector: [".card-view--card-header-image"],
            property: "background-color",
          },
          dependency: [
            {
              field: "generalUseEventAccent",
              value: 0,
              defaultValue: 1,
              message:
                'This option is overwritten by "Use calendar color as accent color" option',
            },
          ],
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Background color",
          templates: [CT.card, CT.cardList, CT.cardSlider],
          name: "cardBgColor",
          defaultValue: "#fff",
          style: {
            selector: [".card-view--card", ".card-slider_card-wrapper"],
            property: "background-color",
          },
          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Drop shadow",
          templates: [CT.cardSlider],
          name: "carBoxShadow",
          defaultValue: "0px 4px 8px 0px rgba(0, 0, 0, 0.17)",
          style: {
            selector: [".card-slider_card-wrapper"],
            property: "box-shadow",
          },
          tooltip: null,
          control: {
            kind: "dropdown",
            options: {
              dropdownOptions: boxShadowOptions,
            },
          },
        },
        {
          title: "Drop shadow",
          templates: [CT.card, CT.cardList],
          name: "carBoxShadow",
          defaultValue: "0px 4px 8px 0px rgba(0, 0, 0, 0.17)",
          style: {
            selector: [".card-view--card"],
            property: "box-shadow",
          },
          tooltip: null,
          control: {
            kind: "dropdown",
            options: {
              dropdownOptions: boxShadowOptions,
            },
          },
        },

        {
          title: "Event title",
          templates: [CT.card, CT.cardList, CT.cardSlider],
          name: "cardEventTitle",
          defaultValue: {
            fontSize: "22px",
            fontWeight: "700",
            letterSpacing: "0px",
            textTransform: "none",
            color: "#333",
          },
          style: {
            selector: [".card-view--card-content-body h2"],
          },
          tooltip: null,
          control: {
            kind: "typography",
            options: {
              showFontSize: true,
              showFontWeight: true,
              showLetterSpacing: true,
              showLineHeight: true,
              showTextTransform: true,
              showColor: true,
              showColorHover: true,
            },
          },
        },
        {
          title: "Event details",
          templates: [CT.card, CT.cardList, CT.cardSlider],
          name: "cardDetailsColor",
          defaultValue: "#333",
          style: [
            {
              selector: ".card-view--card-content-body p",
              property: "color",
            },
          ],

          tooltip: null,
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },

        {
          title: "Event date",
          templates: [CT.card, CT.cardList, CT.cardSlider],
          name: "cardDate",
          defaultValue: {
            fontSize: "14px",
            fontWeight: "400",
            letterSpacing: "0px",
            textTransform: "none",
            color: "#333",
          },
          style: {
            selector: [
              ".card-view--card-content-body p.card-view--card-content-date",
            ],
          },

          tooltip: null,
          control: {
            kind: "typography",
            options: {
              showFontSize: true,
              showFontWeight: true,
              showLetterSpacing: true,
              showLineHeight: true,
              showTextTransform: true,
              showColor: true,
              showColorHover: true,
            },
          },
        },
      ],
    },
    {
      label: "Card Primary call to action",
      options: [
        {
          title: "CTA button box",
          templates: [CT.card, CT.cardList, CT.cardSlider],
          name: "cCardPCTA1stBtnSurface",
          defaultValue: {
            bg: "#00aafb",
            bgHover: "#1ac4ff",
            borderRadius: "8px",
            padding: "8px 24px 8px 24px",
          },
          style: {
            selector: [".dce--event-card--cta-btn"],
            // no hoverSelector -> defaults to `${baseSelector}:hover`
          },
          show: [{ field: "cCardShowCta1st", value: 1, defaultValue: 0 }],
          control: {
            kind: "surface",
            options: {
              showBg: true,
              showBgHover: true,
              showPadding: true,
              showMargin: true,
              showBorderStyle: true,
              showBorderWidth: true,
              showBorderColor: true,
              showBorderRadius: true,
            },
          },
        },
        {
          title: "CTA button label",
          templates: [CT.card, CT.cardList, CT.cardSlider],
          name: "cCardPCTA1stBtnTypography",
          defaultValue: {
            fontSize: "14px",
            fontWeight: "500",
            color: "#fff",
            colorHover: "#fff",
          },
          style: {
            selector: [".dce--event-card--cta-btn"],
          },
          show: [{ field: "cCardShowCta1st", value: 1, defaultValue: 0 }],
          control: {
            kind: "typography",
            options: {
              showFontSize: true,
              showFontWeight: true,
              showColor: true,
              showColorHover: true,
            },
          },
        },
      ],
    },
  ],
};
